import React from 'react';
import { Button, IconButton, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { CSSProperties } from '@material-ui/styles/withStyles';
import { ArrowBackRounded } from '@mui/icons-material';
import { Link } from 'react-router-dom';

import Box from 'retired/Box';

const commonTextStyles: CSSProperties = {
  margin: 0,
  width: '100%',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
};

const useStyles = makeStyles({
  container: {
    borderRadius: 6,
    marginBottom: '50px',
    display: 'flex',
    alignItems: 'center',
    padding: '15px 20px',
  },
  arrowButton: {
    border: '1px solid #eff3f5',
    height: '100%',
    marginRight: '20px',
  },
  titleWrapper: {
    flexGrow: 1,
    overflow: 'hidden',
  },
  titleRow: {
    display: 'flex',
  },
  title: {
    ...commonTextStyles,
    fontWeight: 500,
    fontSize: '18px',
    lineHeight: '22px',
    textTransform: 'capitalize',
    display: 'inline-block',
  },
  subtitle: {
    ...commonTextStyles,
    marginTop: '6px',
    fontSize: '12px',
    lineHeight: '16px',
  },
  rightButtonWrapper: {
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    marginLeft: '20px',
  },
});

const PageHeader: React.FC<{
  title?: React.ReactNode;
  subtitle?: string;
  onArrowClick: (event: React.MouseEvent<HTMLButtonElement>) => void | undefined;
  buttonText?: string;
  linkButton?: { text: string; url: string };
  onButtonClick?: (event: React.MouseEvent<HTMLButtonElement>) => void | undefined;
  buttonType?: 'button' | 'submit';
  buttonDisabled?: boolean;
  isLoading?: boolean;
  id?: string;
}> = ({
  title,
  subtitle,
  onArrowClick,
  buttonText,
  linkButton,
  onButtonClick,
  buttonType,
  buttonDisabled,
  isLoading,
  id,
}) => {
  const classes = useStyles();

  return (
    <Box className={classes.container} id={id}>
      <IconButton className={classes.arrowButton} onClick={onArrowClick}>
        <ArrowBackRounded />
      </IconButton>
      <div className={classes.titleWrapper}>
        <div className={classes.titleRow}>
          <h1 className={classes.title}>{title}</h1>
        </div>

        {!!subtitle && <p className={classes.subtitle}>{subtitle}</p>}
      </div>

      {!!linkButton && (
        <Link
          to={{
            pathname: linkButton.url,
          }}
          target="_blank"
        >
          <Button color="primary" variant="outlined" size="large">
            {linkButton.text}
          </Button>
        </Link>
      )}

      {!!buttonText && (
        <div className={classes.rightButtonWrapper}>
          <Button
            type={buttonType || 'button'}
            color="primary"
            variant="contained"
            onClick={onButtonClick}
            disabled={Boolean(buttonDisabled)}
          >
            {isLoading ? <CircularProgress size={21} /> : buttonText}
          </Button>
        </div>
      )}
    </Box>
  );
};

export default PageHeader;
